import * as React from "react";
const SvgFiBrandsNetflix = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M19.307 14.627q.527.04 1.053.083V8.776h-1.053zM2.372 12.425 1 8.775H0v6.449q.525-.072 1.053-.138V11.58l1.219 3.362q.575-.064 1.152-.121V8.776H2.372zm2.064 2.302q1.455-.127 2.924-.21v-.995q-.94.053-1.871.123v-1.508c.408-.004.945-.016 1.421-.01v-.996c-.38-.001-.991.005-1.421.01V9.78H7.36V8.777H4.436zm3.6-4.946h1.101v4.657q.526-.019 1.054-.032V9.78h1.102V8.776H8.035zm3.932 4.598h1.053v-2.3h1.427v-.995H13.02V9.78h1.886V8.777H11.97zM25 8.776h-1.156l-.763 1.696-.685-1.696h-1.139l1.224 3.03-1.336 2.974q.554.053 1.106.11l.777-1.728.77 1.906q.601.073 1.2.156l.002-.001-1.372-3.396zm-8.367 0H15.58v5.652q1.435.048 2.859.139v-.996q-.9-.057-1.806-.098z"
    />
  </svg>
);
export default SvgFiBrandsNetflix;
